export const isLive = process.env.RAZZLE_BUILD_ENV === 'live'
export const isDev = process.env.NODE_ENV === 'development'
export const isTest = process.env.NODE_ENV === 'test'
export const isProd = process.env.NODE_ENV === 'production'
